module.exports = __webpack_public_path__ + "img/head1.81f19d49.png";